import React, { useEffect, useState } from "react";
import "./Category.css";
import { NavLink } from "react-router-dom";
import { Icon } from "react-icons-kit";
import { arrowUp } from "react-icons-kit/feather/arrowUp";
import { trash } from "react-icons-kit/feather/trash";
import { eye } from "react-icons-kit/feather/eye";
import { arrowUpRight } from "react-icons-kit/feather/arrowUpRight";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import {
  DeleteProduct,
  GetProductPage,
  GetProductCatWithoutPage,
  GetProductSubCatWithoutPage,
} from "../apiconfig/authService";
import { Pagination } from "rsuite";
import "rsuite/dist/rsuite.min.css";

function Product(props) {
  const navigate = useNavigate();
  const { decodedToken, isExpired } = useJwt(
    localStorage.getItem("accessToken")
  );
  if (isExpired) navigate("/");

  const message = props.message;
  const [productsData, setProductsData] = useState([]);
  const [totalProducts, setTotalProducts] = useState(0);
  const [recordIdToDelete, setRecordIdToDelete] = useState("");
  const [refetchData, setRefetchData] = useState(false);
  const [subcategories, setSubcategories] = useState();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [categories, setCategories] = useState();
  const [categoryID, setCategoryID] = useState(-1);
  const [subcategoryID, setSubcategoryID] = useState(-1);
  const [visibleSubcategories, setVisibleSubcategories] = useState();
  const [errorMessage, setErrorMessage] = useState("");

  const handlePerPageRecordsChange = (e) => {
    setItemsPerPage(e.target.value);
    setPageCount(1);
  };

  const formatUTCDate = (utcDateString) => {
    const date = new Date(utcDateString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    };
    const readableFormat = date.toLocaleString(undefined, options);
    return readableFormat.substring(0, readableFormat.length - 9);
  };

  useEffect(() => {
    (async () => {
      try {
        const productsData = await GetProductPage(
          page,
          itemsPerPage,
          search,
          localStorage.getItem("accessToken"),
          categoryID
        );
        setProductsData(productsData.data.products.items);
        console.log(
          "productsData.data.products.items",
          productsData.data.products.items
        );
        setPageCount(
          Math.ceil(productsData.data.products.pagination.pageCount)
        );
        setTotalProducts(productsData.data.products.pagination.count);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [page, itemsPerPage, refetchData]);

  const handleDeleteProductClick = async (productid) => {
    try {
      await DeleteProduct(productid, localStorage.getItem("accessToken"));
      const temp = [...productsData];
      const index = temp.findIndex((item) => item.productid === productid);
      temp.splice(index, 1);
      setProductsData(temp);
      setTotalProducts(totalProducts - 1);
    } catch (error) {
      console.log(error);
    }
  };

  const handleViewProductClick = (productid) => {
    navigate(`/viewProduct/${productid}`);
  };
  const handleEditProductClick = (productid) => {
    navigate(`/editProduct/${productid}`);
  };

  const handlePrevious = () => {
    setPage((p) => {
      if (p === 1) return p;
      return p - 1;
    });
  };
  const handleNext = () => {
    setPage((p) => {
      if (p === pageCount) return p;
      return p + 1;
    });
  };

  //   console.log('visibleSubcategories',visibleSubcategories)

  const handleSubcategoryIDChange = (e) => {
    setSubcategoryID(Number(e.target.value));
  };

  useEffect(() => {
    (async function () {
      const categoryResponse = await GetProductCatWithoutPage(
        localStorage.getItem("accessToken")
      );
      const subCategoryResponse = await GetProductSubCatWithoutPage(
        localStorage.getItem("accessToken")
      );
      setCategories(categoryResponse.data.categories);
      setSubcategories(subCategoryResponse.data.subcategories);
      setVisibleSubcategories(subCategoryResponse.data.subcategories);
    })();
  }, []);

  const handleCategoryIDChange = (e) => {
    setCategoryID(Number(e.target.value));
    setSubcategoryID(-1);
    setVisibleSubcategories(
      subcategories.filter((item) => item.categoryid === e.target.value)
    );
  };

  const handleSearchBoxSubmit = (event) => {
    event.preventDefault();
    setPage(1);
    setRefetchData(!refetchData);
  };

  useEffect(() => {
    if (categoryID !== -1 || subcategoryID == -1) {
      searchProducts();
      // console.log("I'M running category");
    } else if (subcategoryID !== -1 && categoryID === -1) {
      // alert("Please select a category first.");
      // setErrorMessage('Please select a category first');
    } else {
      // Clear error message if no category is selected or both category and subcategory are selected
      // setErrorMessage('');
    }
  }, [categoryID, subcategoryID]);

  const searchProducts = async () => {
    try {
      const productsData = await GetProductPage(
        page,
        itemsPerPage,
        search,
        localStorage.getItem("accessToken"),
        categoryID,
        subcategoryID
      );
      console.log("filterdata", productsData.data.products.items);
      setProductsData(productsData.data.products.items);
      setPageCount(Math.ceil(productsData.data.products.pagination.pageCount));
      setTotalProducts(productsData.data.products.pagination.count);
    } catch (error) {
      console.log(error);
    }
  };

  console.log("subcategoryID", subcategoryID);

  return (
    <div className="dashboard-content">
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={logoImg} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
            </div> */}
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">
            Product Management
            <br />
            <small className="text-primary h6 fw-bold">
              Total counts {totalProducts}
            </small>
          </h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/addProduct" className="btn btn-primary addSeller">
              Add Product
            </NavLink>
          </div>
        </div>
        {/* {errorMessage && <p>{errorMessage}</p>} */}
        <div className="collapse mb-4" id="filter">
          <div className="card card-body">
            <form className="filterForm" action="/">
              <div className="row">
                <div className="col-lg-12 mb-2">
                  <h4 className="text-primary h6 fw-bold">Filter Things</h4>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 mb-2">
                  <div className="form-floating">
                    <select
                      className="form-select"
                      id="floatBilling"
                      aria-label="Billing"
                    >
                      <option defaultValue>Select</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                    <label htmlFor="floatBilling">Billing</label>
                  </div>
                </div>
                <div className="col-lg-4 mb-2">
                  <div className="form-floating">
                    <select
                      className="form-select"
                      id="floatStatus"
                      aria-label="Status"
                    >
                      <option defaultValue>Select</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                    <label htmlFor="floatStatus">Status</label>
                  </div>
                </div>
                <div className="col-lg-4 mb-2">
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg save-btn text-uppercase w-100"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="searchList row">
          <div className="displayRecord d-flex align-items-center col-lg-6 mb-2">
            <span className="h6 mb-0">Display Records</span>
            <select
              className="form-select"
              value={itemsPerPage}
              onChange={handlePerPageRecordsChange}
            >
              <option defaultValue="25">25</option>
              <option value="50">50</option>
              <option value="75">75</option>
              <option value="100">100</option>
              <option value="250">250</option>
            </select>
          </div>

          <div className="searchForm d-flex justify-content-end col-lg-6 mb-2">
            <form className="sForm" onSubmit={handleSearchBoxSubmit}>
              <div className="row">
                <div className="col-lg-6 mb-2">
                  <select
                    className="form-select"
                    value={categoryID}
                    onChange={handleCategoryIDChange}
                  >
                    <option value={-1}>Select a Category</option>
                    {categories
                      ?.sort((a, b) => a.name.localeCompare(b.name)) // Sort categories alphabetically
                      .map((item) => (
                        <option key={item.categoryid} value={item.categoryid}>
                          {item.name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-lg-6 mb-2">
                  <select
                    className="form-select"
                    value={subcategoryID}
                    onChange={handleSubcategoryIDChange}
                    disabled={categoryID === -1}
                  >
                    <option value={-1}>Select a Subcategory</option>
                    {visibleSubcategories
                      ?.sort((a, b) => a.name.localeCompare(b.name)) // Sort subcategories alphabetically
                      .map((item) => (
                        <option
                          key={item.subcategoryid}
                          value={item.subcategoryid}
                        >
                          {item.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <input
                type="text"
                onChange={(event) => {
                  setSearch(event.target.value);
                }}
                className="form-control form-control-lg w-100"
                id="s"
                placeholder="Search"
              />
            </form>
          </div>
        </div>
        {message && (
          <div className="alert alert-primary" role="alert">
            {message}
          </div>
        )}
        <div className="table-responsive">
          <table className="table table-borderless table-hover">
            <thead>
              <tr>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "50px",
                  }}
                  scope="col"
                  width="45"
                  align="center"
                >
                  <div className="selectAll">
                    <input className="form-check-input" type="checkbox" />
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "80px",
                  }}
                  scope="col"
                  width="80"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">SR.</span>
                    <button className="filtBtn idFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "100px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Name</span>
                    <button className="filtBtn sCodeFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "120px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Weight</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "150px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Category</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                {/* <th style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px'}}  scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Image</span>
                                        <button className="filtBtn lNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18}/></button>
                                    </div>
                                </th> */}
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "160px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Subcategory</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "170px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Description</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "140px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Jiomart ID</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "130px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Blinkit ID</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "150px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Bigbasket ID</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "150px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Zepto ID</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "220px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Swiggy InstaMart ID</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "220px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Swiggy Weight</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "220px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Brand Name</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "130px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">DMart URL</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "150px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Amazon Fresh URL</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "150px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Flipcart Grocery URL</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "150px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Image URL</span>
                    <button className="filtBtn fNameFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "230px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Popular Product</span>
                    <button className="filtBtn fNameFilter">

                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "230px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Jiomart Url </span>
                    <button className="filtBtn fNameFilter">

                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "230px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Dmart Weight</span>
                    <button className="filtBtn fNameFilter">

                    </button>
                  </div>
                </th>
                {/* <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "200px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Is Exotic Product?</span>
                    <button className="filtBtn fNameFilter">
                     
                    </button>
                  </div>
                </th> */}
                {/* <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "230px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Is Last Minute Addon?</span>
                    <button className="filtBtn fNameFilter">
                     
                    </button>
                  </div>
                </th> */}
                {/* <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Is Best Sellers?</span>
                                        <button className="filtBtn fNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Is Hot Deals?</span>
                                        <button className="filtBtn fNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Is Trendingin Your Area?</span>
                                        <button className="filtBtn fNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Is Trending Offers?</span>
                                        <button className="filtBtn fNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Is Healthy Snacking?</span>
                                        <button className="filtBtn fNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th> */}
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "300px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Created Date</span>
                    <button className="filtBtn statusFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "300px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Modified Date</span>
                    <button className="filtBtn emailFilter">
                      {/* <Icon className="arrowUp" icon={arrowUp} size={18} /> */}
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "150px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Created By</span>
                    <button className="filtBtn emailFilter">
                      <Icon className="arrowUp" icon={arrowUp} size={18} />
                    </button>
                  </div>
                </th>

                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "200px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Modified By</span>
                    <button className="filtBtn emailFilter">
                      <Icon className="arrowUp" icon={arrowUp} size={18} />
                    </button>
                  </div>
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "150px",
                  }}
                  scope="col"
                >
                  <div className="tableHeadItems position-relative">
                    <span className="text-ellipsis">Action</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="table-group-divider">
              {productsData.map((item, index) => (
                <tr key={item._id}>
                  <td>
                    <input className="form-check-input" type="checkbox" />
                  </td>
                  <td>{index + 1}</td>
                  <td>
                    {item.name && item.name !== "-"
                      ? item.name.slice(0, 25) + "..."
                      : item.name}
                  </td>
                  <td>{item.weight}</td>
                  <td>{item.categoryInfo?.name}</td>
                  <td>{item.subcategoryInfo?.name}</td>
                  <td>
                    {item.description && item.description !== "-"
                      ? item.description.slice(0, 40) + "..."
                      : item.description}
                  </td>
                  <td>{item.jiomartid}</td>
                  <td>{item.blinkitid}</td>
                  <td>{item.bigbasketid}</td>
                  <td>
                    {item.zeptoid && item.zeptoid !== "-"
                      ? item.zeptoid.slice(0, 30) + "..."
                      : item.zeptoid}
                  </td>
                  <td>{item.swiggyinstamartid}</td>
                  <td>{item.swiggyweight}</td>
                  <td>{item.brandname}</td>
                  <td>{item.dmartid}</td>
                  <td>
                    {item.amazonid && item.amazonid !== "-"
                      ? item.amazonid.slice(0, 40) + "..."
                      : item.amazonid}
                  </td>
                  <td>
                    {item.flipkartid && item.flipkartid !== "-"
                      ? item.flipkartid.slice(0, 40) + "..."
                      : item.flipkartid}
                  </td>
                  <td>
                    {item.imageurl != "-"
                      ? item.imageurl.slice(0, 25) + "..."
                      : item.imageurl}
                  </td>
                  <td>{`${item.isPopularProduct}`}</td>
                  <td>{`${item.jiomarturl}`}</td>
                  <td>{`${item.dmartweight}`}</td>
                  {/* <td>{`${item.islastminuteaddon}`}</td> */}

                  <td>{formatUTCDate(item.createddate)}</td>
                  <td>{formatUTCDate(item.modifieddate)}</td>
                  <td>{item.createdby}</td>
                  <td>{item.modifiedby}</td>
                  <td>
                    <div className="d-grid gap-2 d-md-block">
                      <button
                        type="button"
                        onClick={() => {
                          handleViewProductClick(item.productid);
                        }}
                        className="actBtn viewBtn"
                      >
                        <Icon className="eye" icon={eye} size={18} />
                        <span className="toolTip">Preview</span>
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          handleEditProductClick(item.productid);
                        }}
                        className="actBtn editBtn"
                      >
                        <Icon
                          className="arrowUpRight"
                          icon={arrowUpRight}
                          size={18}
                        />
                        <span className="toolTip">Edit</span>
                      </button>{" "}
                      &nbsp;
                      <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        onClick={() => {
                          setRecordIdToDelete(item.productid);
                        }}
                        className="actBtn delBtn"
                      >
                        <Icon className="trash" icon={trash} size={18} />
                        <span className="toolTip">Delete</span>
                      </button>{" "}
                      &nbsp;
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="resultList pt-3 border-top">
          <div className="row">
            <div className="d-flex justify-content-between displayRecord col mb-2">
              {/* <div className=" pb-[20px] pl-[20px] pr-[20px] w-full flex justify-between mt-3"> */}
              {totalProducts === 0 ? (
                <div>Showing 0 - 0 of 0 entries. </div>
              ) : (
                <div>
                  Showing {(page - 1) * itemsPerPage + 1} -{" "}
                  {totalProducts < itemsPerPage * page
                    ? totalProducts
                    : itemsPerPage * page}{" "}
                  of {totalProducts} entries.
                </div>
              )}
              {/* Pagination Start */}
              <div>
                <Pagination
                  prev
                  last
                  next
                  first
                  size="sm"
                  ellipsis
                  boundaryLinks
                  onSelect={setPage}
                  limit={itemsPerPage}
                  onChangeLimit={setItemsPerPage}
                  layout={["pager", "skip"]}
                  pages={pageCount}
                  total={totalProducts}
                  maxButtons={5}
                  activePage={page}
                  onChangePage={(page) => {
                    setPage(page);
                  }}
                />
              </div>
              {/* Pagination End */}
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="10"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body text-center p-5">
                <h1
                  className="modal-title display-6 mb-4"
                  id="exampleModalLabel"
                >
                  Procced with delete?
                </h1>
                <button
                  type="button"
                  className="btn btn-danger me-2"
                  data-bs-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    handleDeleteProductClick(recordIdToDelete);
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Product;
